import { z } from 'zod';
export var FlowDecorationType;
(function (FlowDecorationType) {
    FlowDecorationType["StickyNote"] = "StickyNote";
    FlowDecorationType["GroupNode"] = "GroupNode";
})(FlowDecorationType || (FlowDecorationType = {}));
export const BaseFlowDecorationSchema = z.object({
    id: z.string(),
    decorationType: z.enum(FlowDecorationType),
    position: z.object({
        x: z.number(),
        y: z.number(),
    }),
    groupNodeId: z.string().optional(),
});
//# sourceMappingURL=base.js.map